'use client';

import { cn } from '@/lib/utils';
import { ChevronRight, ChevronsRight } from 'lucide-react';
import { useTranslations } from 'next-intl';
import * as React from 'react';
import { PaginationLink } from '../ui/pagination';

type Props = React.ComponentProps<typeof PaginationLink> & {
    showText?: boolean;
    isSkipIcon?: boolean;
};

const PaginationNext = ({
    className,
    showText = true,
    isSkipIcon = false,
    ...props
}: Props) => {
    const transDef = useTranslations('System');

    return (
        <PaginationLink
            aria-label='Go to next page'
            size='default'
            className={cn(
                'gap-1 pr-2.5',
                {
                    'px-2': !showText,
                },
                className
            )}
            {...props}
        >
            {showText && <span>{transDef('System_NextPage')}</span>}
            {isSkipIcon ? (
                <ChevronsRight className='h-4 w-4' strokeWidth={2} />
            ) : (
                <ChevronRight className='h-4 w-4' strokeWidth={2} />
            )}
        </PaginationLink>
    );
};

export default React.memo(PaginationNext);
